import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import SubproductFeeChargesService from "services/Setup/Organization/subproductFeeChargesService";
import { notification } from "antd";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  SubproductFeeCharges: [],
  getSupProductFee: [],
  getCount: 0,
};

export const getsubproductFeeChargesList = createAsyncThunk(
  "SubproductFeeCharges/getsubproductFeeChargesList",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ getsubproductFeeChargesListuserInput123:", userInput);
    try {
      const response =
        await SubproductFeeChargesService.getsubproductFeeChargesList(
          userInput
        );

      if (response) {
        console.log("get list executed");
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 ~getsubproductFeeChargesList error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getsubproductFeeChargesSearch = createAsyncThunk(
  "SubproductFeeCharges/getsubproductFeeChargesSearch",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await SubproductFeeChargesService.getsubproductFeeChargesSearch(
          userInput
        );
      // console.log("🚀 ~ getSubproductFeeChargesDetailresponse:", response);
      if (response) {
        // console.log("get list executed");
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      // console.log("🚀 ~getsubproductFeeChargesList error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getsubproductFeeChargesApproval = createAsyncThunk(
  "SubproductFeeCharges/getsubproductFeeChargesApproval",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ getsubproductFeeChargesApprovaluserInput:", userInput);
    try {
      const response =
        await SubproductFeeChargesService.getsubproductFeeChargesApproval(
          userInput
        );
      console.log("🚀 ~ getSubproductFeeChargesDetailresponse:", response);
      if (response) {
        console.log("get list executed");
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 ~getsubproductFeeChargesList error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const getsubproductFee = createAsyncThunk(
  "SubproductFeeCharges/getsubproductFee",
  async (userInput, { rejectWithValue }) => {
    console.log("🚀 ~ getsubproductFeeuserInputwerty:", userInput);
    try {
      const response = await SubproductFeeChargesService.getsubproductFee();
      console.log("🚀 ~ getSubproductFeeChargesDetailresponse:", response);
      if (response) {
        console.log("get list executed");
        return response;
      } else {
        return { status: "Ok", message: "Unexpected response!" };
      }
    } catch (error) {
      console.log("🚀 ~getsubproductFeeChargesList error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const postProductFeeChargesList = createAsyncThunk(
  "SubproductFeeCharges/postProductFeeChargesList",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SubproductFeeChargesService.postProductFeeChargesList(data);
      console.log("🚀 ~ response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const editProductFeeChargesList = createAsyncThunk(
  "SubproductFeeCharges/editProductFeeChargesList",
  async (data, { rejectWithValue }) => {
    try {
      const response =
        await SubproductFeeChargesService.editProductFeeChargesList(data);
      console.log("🚀 ~ response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const productFeeChargesReturn = createAsyncThunk(
  "SubproductFeeCharges/productFeeChargesReturn",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~productFeeChargesReturn data:", data);
    try {
      const response =
        await SubproductFeeChargesService.productFeeChargesReturn(data);
      console.log("🚀 ~ response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const productFeeChargesApproval = createAsyncThunk(
  "SubproductFeeCharges/productFeeChargesApproval",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~productFeeChargesApproval data:", data);
    try {
      const response =
        await SubproductFeeChargesService.productFeeChargesApproval(data);
      console.log("🚀 ~ response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const ProductFeeChargesRequest = createAsyncThunk(
  "SubproductFeeCharges/ProductFeeChargesRequest",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ProductFeeChargesRequest data:", data);
    try {
      const response =
        await SubproductFeeChargesService.ProductFeeChargesRequest(data);
      console.log("🚀 ~ response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const ProductFeeChargesReject = createAsyncThunk(
  "SubproductFeeCharges/ProductFeeChargesReject",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~ProductFeeChargesReject data:", data);
    try {
      const response =
        await SubproductFeeChargesService.ProductFeeChargesReject(data);
      console.log("🚀 ~ response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const deleteProductFeeCharges = createAsyncThunk(
  "SubproductFeeCharges/deleteProductFeeCharges",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~deleteProductFeeCharges data:", data);
    try {
      const response =
        await SubproductFeeChargesService.deleteProductFeeCharges(data);
      console.log("🚀 ~ response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const uploadProductFeeCharges = createAsyncThunk(
  "SubproductFeeCharges/uploadProductFeeCharges",
  async (data, { rejectWithValue }) => {
    console.log("🚀 ~uploadProductFeeCharges data:", data);
    try {
      const response =
        await SubproductFeeChargesService.uploadProductFeeCharges(data);
      console.log("🚀 ~ response:", response);

      if (response.status === 200) {
        notification.success({
          message: response.data.status,
          description: response.data.message,
          duration: 3,
        });
        return response;
      } else {
        //Selain Response 200
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ postProductCollection error:", error);
      return rejectWithValue(error.response?.data?.message || "Catched error!");
    }
  }
);

export const SubproductFeeCharges = createSlice({
  name: "subproductFeeCharges",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    falseMessage: (state) => {
      state.message = "";
    },
    rifreshFeeCharges: (state) => {
      state.SubproductFeeCharges = [];
    },
  },

  extraReducers: (builder) => {
    builder

      //getsubproductFee
      .addCase(getsubproductFee.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getsubproductFee.fulfilled, (state, action) => {
        console.log("🚀 ~ .addCase ~ getsubproductFee:", action.payload);
        state.loading = false;
        state.getSupProductFee = action.payload.data;
        console.log("action");
      })
      .addCase(getsubproductFee.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //list
      .addCase(getsubproductFeeChargesList.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getsubproductFeeChargesList.fulfilled, (state, action) => {
        console.log("🚀 ~ .addCase ~ action:", action.payload.data);
        state.loading = false;
        state.SubproductFeeCharges = action.payload.data.data;
        state.getCount = action.payload.data.count;
        console.log("action");
      })
      .addCase(getsubproductFeeChargesList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //search
      .addCase(getsubproductFeeChargesSearch.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getsubproductFeeChargesSearch.fulfilled, (state, action) => {
        console.log("🚀 ~ .addCase ~ action:", action?.payload);
        state.loading = false;
        state.SubproductFeeCharges = action.payload.data.data;
        state.getCount = action.payload.data.count;
        console.log("action");
      })
      .addCase(getsubproductFeeChargesSearch.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //list approval
      .addCase(getsubproductFeeChargesApproval.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getsubproductFeeChargesApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.SubproductFeeCharges = action.payload.data.data;
        state.getCount = action.payload.data.count;
      })
      .addCase(getsubproductFeeChargesApproval.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //post
      .addCase(postProductFeeChargesList.pending, (state) => {
        state.loading = true;
      })
      .addCase(postProductFeeChargesList.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(postProductFeeChargesList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //edit
      .addCase(editProductFeeChargesList.pending, (state) => {
        state.loading = true;
      })
      .addCase(editProductFeeChargesList.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(editProductFeeChargesList.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //product FeeC harges Return
      .addCase(productFeeChargesReturn.pending, (state) => {
        state.loading = true;
      })
      .addCase(productFeeChargesReturn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(productFeeChargesReturn.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //product FeeC Charges approval
      .addCase(productFeeChargesApproval.pending, (state) => {
        state.loading = true;
      })
      .addCase(productFeeChargesApproval.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(productFeeChargesApproval.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //product FeeC Charges Reject
      .addCase(ProductFeeChargesReject.pending, (state) => {
        state.loading = true;
      })
      .addCase(ProductFeeChargesReject.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(ProductFeeChargesReject.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //product FeeC Charges Request
      .addCase(ProductFeeChargesRequest.pending, (state) => {
        state.loading = true;
      })
      .addCase(ProductFeeChargesRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(ProductFeeChargesRequest.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //product FeeC Charges delete
      .addCase(deleteProductFeeCharges.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteProductFeeCharges.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(deleteProductFeeCharges.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })
      //upload sub fee charges
      .addCase(uploadProductFeeCharges.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadProductFeeCharges.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.result = action.payload;
        state.message = "ok";
      })
      .addCase(uploadProductFeeCharges.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      });
  },
});

export const {
  showNotification,
  hideNotification,
  showLoading,
  falseMessage,
  rifreshFeeCharges,
} = SubproductFeeCharges.actions;

export default SubproductFeeCharges.reducer;
